import { createI18n } from 'vue-i18n';

import en from './locales/en.json';
import ru from './locales/ru.json';

/**
 * vue-i18n для accreditation-web. Стартуем сразу с двумя локалями, как в lk-web.
 */
export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: { ru, en },
});

export type Locale = 'ru' | 'en';
